<h1 mat-dialog-title>
  {{title}}
</h1>

<div mat-dialog-content>
  @if (imageUrl) {
    <div class="image-container">
      <!-- Loading indicator -->
      @if (isLoading) {
        <div class="loading-container">
          <mat-spinner diameter="50"></mat-spinner>
          <p>Loading image...</p>
        </div>
      }
      <!-- Image -->
      <img [src]="imageUrl"
        [alt]="title"
        class="popup-image"
        [style.display]="isLoading ? 'none' : 'block'"
        (load)="onImageLoad()"
        (error)="onImageError()">
      </div>
    }
    @if (!imageUrl) {
      <div class="no-image">
        <p>No image available</p>
      </div>
    }
  </div>

  <div mat-dialog-actions>
    <button type="button" mat-raised-button color="primary" (click)="onClose()">Close</button>
  </div>